import React, { useEffect, useState, useRef } from "react";
import {useForm, useFieldArray} from "react-hook-form";
import axios from 'axios';
import DataTable from "react-data-table-component";
import {env} from './const';
import { headers } from '../utils/common';
import { getRole } from '../utils/common';
import { Role } from '../utils/role';
import  DeactivateFarm  from './DeactivateFarm';
import {Modal, Button} from 'react-bootstrap';
import { getUserName } from '../utils/common';
import { useLoading, Bars } from '@agney/react-loading';
import * as axioInstance from '../utils/axiosinstace';
import GrowthCurveComponentNew from "./GrowthCurveComponentNew";
import moment from "moment";
import * as axiosInstance from '../utils/axiosinstace';
import { useTranslation } from 'react-i18next';

import $ from 'jquery';
import 'select2';

const GrowthCurveNew = () => {
  const { t } = useTranslation(['analytics', 'common']);
    const { containerProps, indicatorEl } = useLoading({
        loading: true,
        indicator: <Bars width="30" color="#333" />,
      });
      const [role] = useState(getRole());
    const [farmData, setFarmData] = useState([]);
    const [batchData, setBatchData] = useState([]);
    const [headersobj] = useState(headers());
    const [graphData, setGraphData] = useState({});
    const [showGraph, setShowGraph] = useState(false);
    const [showLoader, setShowloader] = useState(false);
    const { register, handleSubmit, watch, formState: { errors }, setValue, trigger } = useForm({
        mode: 'onChange'
    });

    const onchangeHandler = async(e)=> {
        try {
            setShowData(true);
            const response = await axioInstance.getListofBatches(e.target.value, 'full');
            setBatchData(response.list);
            setShowGraph(false);
        } catch (err) {
            setBatchData([]);
            console.log(err);
        }
    }

    const [xaxis, setXaxis] = useState([]);
    const [showData, setShowData] = useState(true);
    const [maleSeries, setMaleSeries] = useState([]);
    const [femaleSeries, setFemaleSeries] = useState([]);
    const [asHatchedSeries, setAsHatchedSeries] = useState([]);
    const [sexingStatus, setSexingStatus] = useState('no');
    const [tableData, setTableData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [maleLegends, setMaleLegends] = useState([]);
    const [femaleLegends, setFemaleLegends] = useState([]);
    const [chickLegends, setChickLegends] = useState([]);
    const [batchInfo, setBatchInfo] = useState({
        batchName: "",
        batchStatus: "",
        startDate: "",
        endDate: "",
        sexing: "",
        durationDays: 0
    });

    const onSubmit = async(data, e) => {
        e.preventDefault();
        setShowloader(true);
        setErrorMessage('');

        try {
            const response  = await axioInstance.getGrowthCurveData(data.batchID);

            if(response.status === false) {
                setShowData(false);
                setShowloader(false);
                setErrorMessage(response.message);
                return;
            }

            const apiData = response.data;

            if(!apiData || !apiData.days || apiData.days.length === 0) {
                setShowData(false);
                setShowloader(false);
                setErrorMessage('No growth curve data available for this batch');
                return;
            }

            setShowData(false);
            setBatchInfo({
                batchName: apiData.batchName || '',
                batchStatus: apiData.batchStatus || '',
                startDate: apiData.startDate || '',
                endDate: apiData.endDate || '',
                sexing: apiData.sexing,
                durationDays: apiData.durationDays
            });

            // Set x-axis (days)
            setXaxis(apiData.days);
            setSexingStatus(apiData.sexing);

            // Transform data for tables - create array of objects combining all data
            const transformedTableData = apiData.days.map((day, index) => ({
                day: day,
                actualMale: apiData.actualWeightsMale ? apiData.actualWeightsMale[index] : null,
                idealMale: apiData.idealWeightsMale ? apiData.idealWeightsMale[index] : null,
                actualFemale: apiData.actualWeightsFemale ? apiData.actualWeightsFemale[index] : null,
                idealFemale: apiData.idealWeightsFemale ? apiData.idealWeightsFemale[index] : null,
                interpolatedMale: apiData.interpolatedWeightsMale ? apiData.interpolatedWeightsMale[index] : null,
                interpolatedFemale: apiData.interpolatedWeightsFemale ? apiData.interpolatedWeightsFemale[index] : null,
                isInterpolatedMale: apiData.isInterpolatedMale ? apiData.isInterpolatedMale[index] : false,
                isInterpolatedFemale: apiData.isInterpolatedFemale ? apiData.isInterpolatedFemale[index] : false
            }));

            setTableData(transformedTableData);

            if(apiData.sexing === 'no') {
                const asHatchedSeriesData = [];
                const hasInterp = !!apiData.interpolatedWeightsMale;

                // Build merged actual+interpolated line data and separate estimated-only dots
                const mergedWeights = [];
                const estimatedWeights = [];

                apiData.days.forEach((day, index) => {
                    const maleWeight = apiData.actualWeightsMale[index];
                    const femaleWeight = apiData.actualWeightsFemale ? apiData.actualWeightsFemale[index] : null;
                    let val = null;
                    if (maleWeight !== null && femaleWeight !== null) {
                        val = ((maleWeight + femaleWeight) / 2) / 1000;
                    } else if (maleWeight !== null) {
                        val = maleWeight / 1000;
                    } else if (femaleWeight !== null) {
                        val = femaleWeight / 1000;
                    }

                    const isInterp = hasInterp && apiData.isInterpolatedMale && apiData.isInterpolatedMale[index];
                    if (val === null && isInterp && apiData.interpolatedWeightsMale[index] !== null) {
                        val = apiData.interpolatedWeightsMale[index] / 1000;
                    }

                    mergedWeights.push(val);
                    estimatedWeights.push(isInterp ? val : null);
                });

                const idealWeights = apiData.days.map((day, index) => {
                    const maleIdeal = apiData.idealWeightsMale[index];
                    const femaleIdeal = apiData.idealWeightsFemale ? apiData.idealWeightsFemale[index] : null;

                    if (maleIdeal !== null && femaleIdeal !== null) {
                        return ((maleIdeal + femaleIdeal) / 2) / 1000;
                    }
                    if (maleIdeal !== null) return maleIdeal / 1000;
                    if (femaleIdeal !== null) return femaleIdeal / 1000;
                    return null;
                });

                asHatchedSeriesData.push({
                    name: t('analytics:growth.actualWeight'),
                    type: 'line',
                    smooth: true,
                    data: mergedWeights,
                    connectNulls: true
                });

                asHatchedSeriesData.push({
                    name: t('analytics:growth.idealWeight'),
                    type: 'line',
                    smooth: true,
                    data: idealWeights,
                    connectNulls: true
                });

                if (hasInterp) {
                    asHatchedSeriesData.push({
                        name: t('analytics:growth.estimatedWeight'),
                        type: 'line',
                        smooth: true,
                        data: estimatedWeights,
                        lineStyle: { width: 0 },
                        itemStyle: { color: '#FF8C00' },
                        connectNulls: false
                    });
                    setChickLegends(['Actual Weight', 'Ideal Weight', 'Estimated Weight']);
                } else {
                    setChickLegends(['Actual Weight', 'Ideal Weight']);
                }

                setAsHatchedSeries(asHatchedSeriesData);
                setShowloader(false);

                return;
            }

            // For sexed batches
            const maleSeriesData = [];
            const femaleSeriesData = [];

            const hasMaleInterp = !!apiData.interpolatedWeightsMale;
            const maleMerged = [];
            const maleEstimated = [];

            apiData.actualWeightsMale.forEach((w, index) => {
                const isInterp = hasMaleInterp && apiData.isInterpolatedMale && apiData.isInterpolatedMale[index];
                let val = w !== null ? w / 1000 : null;
                if (val === null && isInterp && apiData.interpolatedWeightsMale[index] !== null) {
                    val = apiData.interpolatedWeightsMale[index] / 1000;
                }
                maleMerged.push(val);
                maleEstimated.push(isInterp ? val : null);
            });

            maleSeriesData.push({
                name: t('analytics:growth.maleActual'),
                type: 'line',
                smooth: true,
                data: maleMerged,
                connectNulls: true
            });

            maleSeriesData.push({
                name: t('analytics:growth.maleIdeal'),
                type: 'line',
                smooth: true,
                data: apiData.idealWeightsMale.map(w => w !== null ? w / 1000 : null),
                connectNulls: true
            });

            if (hasMaleInterp) {
                maleSeriesData.push({
                    name: t('analytics:growth.maleEstimated'),
                    type: 'line',
                    smooth: true,
                    data: maleEstimated,
                    lineStyle: { width: 0 },
                    itemStyle: { color: '#FF8C00' },
                    connectNulls: false
                });
                setMaleLegends(['Male Actual Weight', 'Male Ideal Weight', 'Male Estimated Weight']);
            } else {
                setMaleLegends(['Male Actual Weight', 'Male Ideal Weight']);
            }
            setMaleSeries(maleSeriesData);

            const hasFemaleInterp = !!apiData.interpolatedWeightsFemale;
            const femaleMerged = [];
            const femaleEstimated = [];

            apiData.actualWeightsFemale.forEach((w, index) => {
                const isInterp = hasFemaleInterp && apiData.isInterpolatedFemale && apiData.isInterpolatedFemale[index];
                let val = w !== null ? w / 1000 : null;
                if (val === null && isInterp && apiData.interpolatedWeightsFemale[index] !== null) {
                    val = apiData.interpolatedWeightsFemale[index] / 1000;
                }
                femaleMerged.push(val);
                femaleEstimated.push(isInterp ? val : null);
            });

            femaleSeriesData.push({
                name: t('analytics:growth.femaleActual'),
                type: 'line',
                smooth: true,
                data: femaleMerged,
                connectNulls: true
            });

            femaleSeriesData.push({
                name: t('analytics:growth.femaleIdeal'),
                type: 'line',
                smooth: true,
                data: apiData.idealWeightsFemale.map(w => w !== null ? w / 1000 : null),
                connectNulls: true
            });

            if (hasFemaleInterp) {
                femaleSeriesData.push({
                    name: t('analytics:growth.femaleEstimated'),
                    type: 'line',
                    smooth: true,
                    data: femaleEstimated,
                    lineStyle: { width: 0 },
                    itemStyle: { color: '#FF8C00' },
                    connectNulls: false
                });
                setFemaleLegends(['Female Actual Weight', 'Female Ideal Weight', 'Female Estimated Weight']);
            } else {
                setFemaleLegends(['Female Actual Weight', 'Female Ideal Weight']);
            }
            setFemaleSeries(femaleSeriesData);
            setShowloader(false);

        } catch (err) {
            setShowData(false);
            setShowloader(false);
            setErrorMessage('Error fetching growth curve data: ' + (err.message || 'Unknown error'));
            console.error(err);
        }
    }

    const onBatchChange = (e)=>{
        setShowGraph(false);
    }

    const getFarms = async(_userName)=>{
        try {
            let userName = getUserName();
            if(role === Role.Admin) {
                userName = _userName;
            }

            const response = await axioInstance.getListofFarms(userName);

            setFarmData(response.list)
        } catch (err) {
            console.log(err.message);
        }
    }

    const [selectedFarmer, setSelectedFarmer] = useState("");
    const getFarms_admin = async (farmerID) => {
        try {
            const response = await axiosInstance.getListofFarms_active_admin(farmerID);
            setFarmData(response.list);

        } catch (err) {
            console.log(err.message);
        }
    }

    const [farmers, setFarmers] = useState([]);
    const getFarmers = async () => {
        try {
            const response = await axiosInstance.getListofFarmers_admin();
            setFarmers(response.list);
        } catch (err) {
            console.log(err.message);
        }
    }

    useEffect(() => {
        if (role === Role.Admin) {
            getFarmers();
        } else {
            getFarms('')
        }

    }, []);

    useEffect(() => {
        const farmerSelect = $("#selectFarmer").select2();
        farmerSelect.on("change", function (e) {
          const selectedFarmerID = e.target.value;
          setSelectedFarmer(selectedFarmerID);
          setBatchData([]);
          setShowData(true);
          setShowGraph(false);
          if (role === Role.Admin) {
            getFarms(selectedFarmerID)
          }
        });

        const farmSelect = $("#selectFarm").select2();
        farmSelect.on("change", function (e) {
          trigger("famrmID");
          setValue("famrmID", e.target.value, { shouldValidate: true });
          onchangeHandler(e);
        });

        return () => {
          farmerSelect.off("change");
          farmerSelect.select2("destroy");
          farmSelect.off("change");
          farmSelect.select2("destroy");
        };
      }, [farmData]);

    return (
        <div className="batchOperations">
            <div className="row mb-2">
                <div className="col-sm-6">
                    <h2 className="m-0 text-dark">{t('analytics:growth.title')}</h2>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>

                        <div className="row">
                        {
                                role === Role.Admin ?
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>{t('common:select.farmer')}</label>
                                            <select
                                                style={{ width: "100%" }}
                                                id="selectFarmer"
                                                className="form-control form-control-sm">
                                                <option value="">{t('common:select.dashed')}</option>
                                                {farmers.map(item => (
                                                    <option
                                                        key={item.id}
                                                        value={item.userName}
                                                    >
                                                        {item.farmerName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    : <></>}
                            <div className="col-md-3">
                                <div className="form-group">
                                   <label>{t('common:select.barn')}</label>
                                    <select className="form-control" name="famrmID" id="selectFarm"
                                    {...register("famrmID", { required: true })}
                                    >
                                        <option value="">{t('common:select.dashed')}</option>
                                        {farmData.map(item => (
                                                <option
                                                  key={item.farmID}
                                                  value={item.farmID}
                                                >
                                                  {item.farmName}
                                                </option>
                                              ))}
                                    </select>
                                    {errors.famrmID && <span className="err-msg">{t('common:validation.selectBarn')}</span>}
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>{t('common:select.batch')}</label>
                                    <select className="form-control" name="batchID" onChange={onBatchChange}
                                   {...register("batchID", { required: true })}
                                    >
                                        <option value="">{t('common:select.dashed')}</option>
                                        {batchData.map(item => (
                                                <option
                                                  key={item.batchID}
                                                  value={item.batchID}
                                                >
                                                  {item.batchName}

                                                </option>
                                              ))}
                                    </select>
                                    {errors.batchID && <span className="err-msg">{t('common:validation.selectBatch')}</span>}
                                </div>
                            </div>
                            <div className="col-md-1 form-group">
                                <div className="spacer"></div>
                                <input type="submit" value="Fetch" className="btn btn-primary" />
                            </div>
                            <div className='col-md-1'>
                                { showLoader?
                                     <section {...containerProps} style={{"marginTop": "30px"}}>
                                        {indicatorEl}
                                    </section> :""
                                }
                            </div>
                        </div>
                </form>
                    {
                        showData?
                        <div className="row">
                            <div className="col-md-12">
                                <p className="redColor">{errorMessage}</p>
                            </div>
                        </div>
                        :
                        <div className="row">
                            <div className="col-md-12">
                                <GrowthCurveComponentNew
                                    key={Math.random()}
                                    data={tableData}
                                    xaxis={xaxis}
                                    legends={[]}
                                    sexing={sexingStatus}
                                    maleseries={maleSeries}
                                    femaleseries={femaleSeries}
                                    asHatchedSeries={asHatchedSeries}
                                    max='4'
                                    maleLegends={maleLegends}
                                    femaleLegends={femaleLegends}
                                    chickLegends={chickLegends}
                                    batchInfo={batchInfo}
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>

    );
}

export default GrowthCurveNew;
